import React from "react";
import styles from "./Footer.module.css";

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div style={{ flex: 1 }}></div>
          <div
            className={styles.copyright}
            style={{ textAlign: "center", flex: 1 }}
          >
            &copy; {new Date().getFullYear()} Monulink. All rights reserved.
          </div>
          <div style={{ flex: 1 }}></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
